import {
  Component,
  ElementRef,
  Input,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';
@Component({
    selector: 'app-auctions-statistics',
        standalone: true,
imports: [RouterLink,
        TranslatePipe
    ],
    templateUrl: './auctions-statistics.component.html',
    styleUrl: './auctions-statistics.component.scss'
})
export class AuctionsStatisticsComponent {
  @Input() statistics: any = null;
  @Input() translations: any;
}
